import React, { Component, useState, useEffect } from 'react'
import AuthenticationService from './AuthenticationService'

class UnauthorizedComponent extends Component {
    constructor(props) {
        super(props)
        this.state = { visible: false }
    }

    componentDidMount() {
        requestAnimationFrame(() => this.setState({ visible: true }))
    }

    goBack = () => {
        if (this.props.history && this.props.history.length > 2) {
            this.props.history.goBack()
        } else if (this.props.history) {
            this.props.history.push('/welcome/' + AuthenticationService.getLoggedInUserName())
        }
    }

    render() {
        const usuario = this.props.usuario || AuthenticationService.getLoggedInUserName()
        const { visible } = this.state

        return (
            <>
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
                    .unauth * { font-family: 'Inter', sans-serif; box-sizing: border-box; }

                    .unauth-overlay {
                        position: fixed;
                        inset: 0;
                        z-index: 900;
                        background: rgba(2, 6, 23, 0.65);
                        backdrop-filter: blur(10px);
                        -webkit-backdrop-filter: blur(10px);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding: 24px;
                        transition: opacity 0.28s ease;
                    }
                    .unauth-overlay.unauth-hidden { opacity: 0; pointer-events: none; }
                    .unauth-overlay.unauth-shown  { opacity: 1; }

                    .unauth-card {
                        position: relative;
                        width: 100%;
                        max-width: 490px;
                        border-radius: 24px;
                        background: linear-gradient(145deg, rgba(15,23,42,0.97) 0%, rgba(15,20,40,0.97) 100%);
                        border: 1px solid rgba(255,255,255,0.1);
                        box-shadow:
                            0 0 0 1px rgba(255,255,255,0.04) inset,
                            0 32px 80px rgba(0,0,0,0.6),
                            0 0 100px rgba(99,102,241,0.1);
                        overflow: hidden;
                        transition: opacity 0.28s ease, transform 0.28s cubic-bezier(0.34,1.56,0.64,1);
                    }
                    .unauth-card.unauth-hidden { opacity: 0; transform: translateY(24px) scale(0.96); }
                    .unauth-card.unauth-shown  { opacity: 1; transform: translateY(0) scale(1); }

                    .unauth-glow-tr {
                        position: absolute; top: -80px; right: -60px;
                        width: 280px; height: 280px; border-radius: 50%;
                        background: radial-gradient(circle, rgba(99,102,241,0.2) 0%, transparent 70%);
                        pointer-events: none;
                    }
                    .unauth-glow-bl {
                        position: absolute; bottom: -60px; left: -40px;
                        width: 200px; height: 200px; border-radius: 50%;
                        background: radial-gradient(circle, rgba(239,68,68,0.12) 0%, transparent 70%);
                        pointer-events: none;
                    }

                    /* ── header centrado ── */
                    .unauth-header {
                        padding: 36px 32px 28px;
                        border-bottom: 1px solid rgba(255,255,255,0.07);
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        text-align: center;
                    }
                    .unauth-badge {
                        display: inline-flex; align-items: center; gap: 7px;
                        background: rgba(239,68,68,0.1);
                        border: 1px solid rgba(239,68,68,0.3);
                        border-radius: 20px; padding: 4px 13px;
                        font-size: 0.68rem; font-weight: 800; color: #f87171;
                        letter-spacing: 0.8px; text-transform: uppercase;
                        margin-bottom: 20px;
                    }
                    .unauth-badge-dot {
                        width: 6px; height: 6px; border-radius: 50%;
                        background: #f87171; box-shadow: 0 0 8px #f87171;
                        animation: unauth-pulse 2s infinite;
                    }
                    @keyframes unauth-pulse {
                        0%, 100% { opacity: 1; transform: scale(1); }
                        50%       { opacity: 0.5; transform: scale(0.75); }
                    }
                    .unauth-lock {
                        width: 56px; height: 56px;
                        background: rgba(99,102,241,0.12);
                        border: 1px solid rgba(99,102,241,0.25);
                        border-radius: 16px;
                        display: flex; align-items: center; justify-content: center;
                        margin-bottom: 20px; font-size: 1.5rem;
                    }
                    .unauth-title {
                        font-size: 1.35rem; font-weight: 800; color: #f8fafc;
                        margin: 0 0 10px; letter-spacing: -0.3px;
                    }
                    .unauth-sub {
                        font-size: 0.84rem; color: rgba(255,255,255,0.45);
                        line-height: 1.65; margin: 0; max-width: 360px;
                    }
                    .unauth-sub strong { color: rgba(255,255,255,0.75); font-weight: 600; }

                    /* ── body ── */
                    .unauth-body { padding: 24px 32px 28px; }

                    .unauth-section-label {
                        font-size: 0.65rem; font-weight: 700;
                        color: rgba(255,255,255,0.25); letter-spacing: 1px;
                        text-transform: uppercase; margin-bottom: 10px;
                    }
                    .unauth-contact {
                        background: rgba(255,255,255,0.04);
                        border: 1px solid rgba(255,255,255,0.08);
                        border-radius: 14px; overflow: hidden; margin-bottom: 20px;
                    }
                    .unauth-contact-row {
                        display: flex; align-items: center; gap: 14px; padding: 14px 18px;
                    }
                    .unauth-contact-row:not(:last-child) {
                        border-bottom: 1px solid rgba(255,255,255,0.06);
                    }
                    .unauth-contact-icon {
                        width: 34px; height: 34px; border-radius: 10px;
                        display: flex; align-items: center; justify-content: center;
                        flex-shrink: 0; font-size: 1rem;
                    }
                    .unauth-contact-main { font-size: 0.875rem; font-weight: 600; color: #f1f5f9; }
                    .unauth-contact-sub  { font-size: 0.72rem; color: rgba(255,255,255,0.35); margin-top: 1px; }

                    .unauth-steps {
                        background: rgba(99,102,241,0.07);
                        border: 1px solid rgba(99,102,241,0.18);
                        border-radius: 14px; padding: 16px 18px; margin-bottom: 24px;
                    }
                    .unauth-steps-title {
                        font-size: 0.65rem; font-weight: 700;
                        color: rgba(165,167,255,0.7); letter-spacing: 1px;
                        text-transform: uppercase; margin-bottom: 12px;
                    }
                    .unauth-step {
                        display: flex; align-items: flex-start; gap: 10px;
                        padding: 5px 0; font-size: 0.82rem;
                        color: rgba(255,255,255,0.5); line-height: 1.5;
                    }
                    .unauth-step strong { color: rgba(255,255,255,0.75); }
                    .unauth-step-num {
                        min-width: 20px; height: 20px;
                        background: rgba(99,102,241,0.35); color: #a5b4fc;
                        border-radius: 50%; font-size: 0.65rem; font-weight: 800;
                        display: flex; align-items: center; justify-content: center;
                        margin-top: 1px; flex-shrink: 0;
                    }

                    .unauth-btn {
                        width: 100%; padding: 13px 24px;
                        background: rgba(255,255,255,0.07);
                        color: rgba(255,255,255,0.8);
                        border: 1px solid rgba(255,255,255,0.12);
                        border-radius: 12px; font-size: 0.875rem; font-weight: 600;
                        cursor: pointer; font-family: 'Inter', sans-serif;
                        letter-spacing: 0.2px;
                        transition: background 0.18s, border-color 0.18s, color 0.18s, transform 0.15s;
                    }
                    .unauth-btn:hover {
                        background: rgba(255,255,255,0.12);
                        border-color: rgba(255,255,255,0.22);
                        color: #f8fafc; transform: translateY(-1px);
                    }
                    .unauth-btn:active { transform: translateY(0); }

                    .unauth-footer {
                        padding: 14px 32px;
                        border-top: 1px solid rgba(255,255,255,0.06);
                        display: flex; align-items: center; justify-content: center;
                        gap: 8px; font-size: 0.68rem; color: rgba(255,255,255,0.2);
                    }
                `}</style>

                <div className={`unauth unauth-overlay ${visible ? 'unauth-shown' : 'unauth-hidden'}`}>
                    <div className={`unauth-card ${visible ? 'unauth-shown' : 'unauth-hidden'}`}>
                        <div className="unauth-glow-tr" />
                        <div className="unauth-glow-bl" />

                        <div className="unauth-header">
                            <div className="unauth-badge">
                                <span className="unauth-badge-dot" />
                                Acceso Restringido
                            </div>
                            <div className="unauth-lock">🔒</div>
                            <h2 className="unauth-title">Sin permisos de edición</h2>
                            <p className="unauth-sub">
                                Tu cuenta <strong>{usuario}</strong> tiene acceso de solo lectura.
                                Para editar este registro, solicita los permisos al administrador del sistema.
                            </p>
                        </div>

                        <div className="unauth-body">
                            <div className="unauth-section-label">Contactar administrador</div>
                            <div className="unauth-contact">
                                <div className="unauth-contact-row">
                                    <div className="unauth-contact-icon" style={{ background: 'rgba(99,102,241,0.15)' }}>👤</div>
                                    <div>
                                        <div className="unauth-contact-main">Sistemas01</div>
                                        <div className="unauth-contact-sub">Administrador del Sistema</div>
                                    </div>
                                </div>
                                <div className="unauth-contact-row">
                                    <div className="unauth-contact-icon" style={{ background: 'rgba(52,211,153,0.1)' }}>💬</div>
                                    <div>
                                        <div className="unauth-contact-main">Solicitar por mensaje</div>
                                        <div className="unauth-contact-sub">Indica tu usuario y el módulo requerido</div>
                                    </div>
                                </div>
                            </div>

                            <div className="unauth-steps">
                                <div className="unauth-steps-title">¿Cómo solicitar acceso?</div>
                                <div className="unauth-step">
                                    <span className="unauth-step-num">1</span>
                                    <span>Contacta a <strong>Sistemas01</strong> e indica tu usuario: <strong>{usuario}</strong></span>
                                </div>
                                <div className="unauth-step">
                                    <span className="unauth-step-num">2</span>
                                    <span>Especifica el módulo o registro al que necesitas acceso</span>
                                </div>
                                <div className="unauth-step">
                                    <span className="unauth-step-num">3</span>
                                    <span>El administrador asignará los permisos en tu perfil</span>
                                </div>
                            </div>

                            <button className="unauth-btn" onClick={this.goBack}>
                                ← Volver
                            </button>
                        </div>

                        <div className="unauth-footer">
                            <span>Cloud Zenyth by KrvheD</span>
                            <span>·</span>
                            <span>© 2026</span>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default UnauthorizedComponent
